module.exports = __webpack_public_path__ + "static/img/zentek.8675075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zentek.png
// module id = NRdH
// module chunks = 1